import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';
import InputLabel from 'src/components/atoms/form/InputLabel';
import RequiredLabel from 'src/components/atoms/form/RequiredLabel';

type Props = {
  isRequired: boolean | undefined;
  labelName: string;
};

export const InputLabelHolder = ({ ...props }: Props) => {
  return (
    <Styled>
      <div className="label_holder">
        <InputLabel labelName={props.labelName} />
        {props.isRequired ? <RequiredLabel className={'is-required'} /> : null}
      </div>
    </Styled>
  );
};

const Styled = styled.div`
  box-sizing: border-box;
  margin-bottom: ${StyleConfig.HELPER.M8};
  > .label_holder {
    display: flex;
    align-items: center;
    .is-required {
      margin-left: ${StyleConfig.HELPER.M8};
      min-width: 25px;
    }
  }
`;
export default InputLabelHolder;
